import React, { useState, useEffect } from "react";
import { useField } from "formik";
import { at } from "lodash";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { InputLabel } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const DatePickerField = (props) => {
  const { label, maxDate, height, width, isYearSelect, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const [error, touched] = at(meta, "error", "touched");
  const { setValue } = helper;
  const { value } = field;
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (value) {
      const date = dayjs.utc(value);
      setSelectedDate(date);
    }
  }, [value]);

  const onChange = (date) => {
    if (date) {
      setSelectedDate(date);
      try {
        const formattedDate = dayjs(date).format("YYYY-MM-DD");
        setValue(formattedDate);
      } catch (error) {
        setValue(date);
      }
    } else {
      setValue(date);
    }
  };

  const renderHelperText = () => {
    if (error && touched) {
      return error;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <InputLabel htmlFor="DatePicker-input">{label}</InputLabel>
      <DemoContainer
        components={["DatePicker"]}
        sx={{ padding: "0", overflow: "visible" }}
      >
        <DatePicker
          {...field}
          {...rest}
          id={label}
          maxDate={maxDate ? dayjs(maxDate) : null}
          value={selectedDate ? dayjs(selectedDate) : null}
          views={isYearSelect ? ["year"] : ["year", "month", "day"]}
          onChange={onChange}
          sx={{ height: "auto", width: width || "270px" }}
          slotProps={{
            textField: {
              size: "small",
              error: !!error && touched,
              helperText: renderHelperText(),
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};
export default DatePickerField;
